// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__j538z","main":"Modal_main__2Nqzs","footer":"Modal_footer__32mp9","footer_space":"Modal_footer_space__iLL5G","footer_count":"Modal_footer_count__V1tjb"};